// Event Bus BCF integrační vrstvy (§23). Publikuje doménové události, na které se
// mohou napojit další části aplikace bez přímé závislosti na BCF logice.
export const BCFEvents = Object.freeze([
  "bcf.project.loaded",
  "bcf.topic.created",
  "bcf.topic.updated",
  "bcf.topic.deleted",
  "bcf.topic.opened",
  "bcf.comment.created",
  "bcf.comment.updated",
  "bcf.comment.deleted",
  "bcf.viewpoint.created",
  "bcf.viewpoint.applied",
  "bcf.workflow.changed",
  "bcf.error",
]);

export class BCFEventBus {
  constructor() { this._map = new Map(); }
  on(event, handler) {
    if (!this._map.has(event)) this._map.set(event, new Set());
    this._map.get(event).add(handler);
    return () => this.off(event, handler);
  }
  off(event, handler) { const s = this._map.get(event); if (s) s.delete(handler); }
  emit(event, payload) {
    const s = this._map.get(event);
    if (s) for (const h of Array.from(s)) { try { h(payload); } catch (e) { if (event !== "bcf.error" && typeof console !== "undefined") console.error("[BCF] handler error", e); } }
    // Zrcadlení na wildcard posluchače.
    const all = this._map.get("*");
    if (all) for (const h of Array.from(all)) { try { h({ event, payload }); } catch (_) {} }
  }
  clear() { this._map.clear(); }
}
